import { createGlobalStyle } from 'styled-components';
import { cssReset } from './cssReset';

export var GlobalStyle = createGlobalStyle(["", " a,button{cursor:pointer;}"],
cssReset);
//# sourceMappingURL=GlobalStyle.js.map